<template>
  <div>
    <!-- Botón para disparar la confirmación de cierre del grupo -->
    <button @click="showModal = true" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-5 rounded">
      Cerrar Grupo
    </button>

    <!-- Modal de confirmación -->
    <div v-if="showModal" class="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4">
      <div class="bg-white p-5 rounded-lg shadow">
        <h3 class="text-lg font-bold">Confirmación</h3>
        <p class="my-4">¿Está seguro de que desea cerrar el grupo?</p>
        <span>Asegurate de haber guardado tus cambios antes de continuar, una vez cerrado el grupo no podras realizar modificaciones en los usuarios.</span>
        
        <div class="flex justify-end mt-3">
          <button @click="showModal = false" class="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-5 rounded mr-2">
            Cancelar
          </button>
          <button @click="closeGroup" class="bg-green-500 hover:bg-green-700 text-white font-bold py-1 px-5 rounded">
            Cerrar Grupo
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';

export default {
  props: {
    grupoToken: {
      type: String,
      required: true
    }
  },
  setup() {
      const toast = useToast();
      return { toast };
    },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    closeGroup() {
      this.showModal = false; // Cerrar modal inmediatamente al enviar
      axios.post('/api/group/close', { groupToken: this.grupoToken })
        .then(response => {
          console.log(response)
          this.toast.success('Grupo cerrado correctamente. La página se recargará en 5 segundos.', { timeout: 5000 });
          setTimeout(() => {
            location.reload();
          }, 5000);
        })
        .catch(error => {
          console.error('Error al cerrar el grupo:', error);
          this.$toast.error('Error al procesar la solicitud.');
        });
    }
  }
}
</script>

<style scoped>
button {
  transition: background-color 0.3s ease;
  font-size: 0.85em;
}

.fixed {
  z-index: 1000; 
}
button {

background: rgb(61, 67, 91)!important;
border-radius: 3px!important;
}

</style>
